import React, {Suspense} from 'react'
import {useRoutes, Navigate} from 'react-router-dom'
import {Spin} from 'antd'
import About from '../components/pages/About'
import Unauthorized from '../components/pages/Unauthorized'
import Issues from '../modules/issues/Issues'
import Events from '../modules/events/Events'
import Plans from '../modules/plans/Plans'
import Indicators from '../modules/indicators/Indicators'
import Dashboard from '../modules/dashboard/Dashboard'
import Documents from '../modules/common/Documents'
import Reports from '../components/pages/Reports'
import Settings from '../components/pages/Settings'
import Home from "../modules/settings/Home";
import IssueDetail from "../modules/issues/detail/IssueDetail";
import Risks from "../modules/risks/Risks";
import IssueForm from "../modules/issues/detail/panels/IssueForm";
import EventDetail from "../modules/events/detail/EventDetail";

const AppRouter: React.FC = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <Home/>,
      children: [
        {
          index: true,
          element: <Navigate to="/issues" replace/>
        },
        {
          path: "about",
          element: <About/>
        },
        {
          path: "issues",
          element: <Issues/>
        },
        {
          path: "events",
          element: (<Events/>)
        },
        {
          path: "events/:id",
          element: <EventDetail/>
        },
        {
          path: "risks",
          element: <Risks module={""}/>
        },
        {
          path: "plans",
          element: <Plans/>
        },
        {
          path: "indicators",
          element: <Indicators/>
        },
        {
          path: "dashboard",
          element: <Dashboard/>
        },
        {
          path: "documents",
          element: <Documents/>
        },
        {
          path: "reports",
          element: <Reports/>
        },
        {
          path: "settings/*",
          element: <Settings/>
        },
        {
          path: "detail/:id?/issue-form",
          element: <IssueForm/>
        },
        {
          path: "detail/:id?",
          element: <IssueDetail/>
        }
      ]
    },
    {
      path: "/unauthorized",
      element: <Unauthorized/>
    }
  ])

  return (
    <Suspense fallback={<Spin size="large" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh'}}/>}>
      {routes}
    </Suspense>
  )
}

export default AppRouter
